import React, { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import ApiService from '../../services/ApiService';
import AddNote from './AddNote';

const ViewNotes = ({ listName = '', listItem = '' }) => {
  const [showAddNote, setShowAddNote] = useState(false);
  const [noteList, setNoteList] = useState([]);

  const submitCallback = () => {
    fetchNotes();
    setShowAddNote(false);
  };

  const fetchNotes = () => {
    ApiService.get('notes', { params: { listId: listName, itemId: listItem } }).then(response => {
      setNoteList(response.data);
    });
  };

  const removeNote = noteId => {
    ApiService.delete(`note/${noteId}`).then(response => {
      fetchNotes();
    });
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  return (
    <div className="view-notes">
      {showAddNote === true ? (
        <AddNote
          itemId={listItem}
          listId={listName}
          submitCallback={submitCallback}
          onCancel={() => setShowAddNote(false)}
        />
      ) : (
        <>
          {noteList.map(note => {
            return (
              <div key={note.id}>
                <Card className="mb-2" style={{ backgroundColor: 'var(--yellow-0)' }}>
                  <div className="card-toolbar">
                    <div className="card-toolbar-button" title="Delete Note" onClick={() => removeNote(note.id)}>
                      <i className="fal fa-times fa-fw" />
                    </div>
                  </div>
                  <Card.Body>
                    <Card.Title>{note.title}</Card.Title>
                    <Card.Text>{note.body}</Card.Text>
                  </Card.Body>
                </Card>
              </div>
            );
          })}
          <Button className="mt-2" variant="success" onClick={() => setShowAddNote(true)}>
            Add Note
          </Button>
        </>
      )}
    </div>
  );
};

export default ViewNotes;
